import { TweenMax } from 'gsap/all'
import { math } from '../core/store.js'

export class Magnetic {
  constructor (parent, child) {
    this.parent = parent
    this.child = child
    this.lerp = 0.2
    this.paused = true

    this.init()
  }

  init = () => {
    this.resize()
    this.setDefaults()
    this.bindEvents()
  }

  resize = () => {
    this.parentRect = this.parent.getBoundingClientRect()
    this.parentLeft = this.parentRect.left
    this.parentTop = this.parentRect.top
    this.parentWidth = this.parentRect.width
    this.parentHeight = this.parentRect.height

    this.childRect = this.child.getBoundingClientRect()
    this.childWidth = this.childRect.width
    this.childHeight = this.childRect.height
  }

  setDefaults = () => {
    let defaultX = this.parentWidth / 2 - this.childWidth / 2
    let defaultY = this.parentHeight / 2 - this.childHeight / 2
    this.scrollOffset = 0
    this.x = defaultX
    this.y = defaultY
    this.mouseX = defaultX
    this.mouseY = defaultY
    TweenMax.set(this.child, {
      x: defaultX,
      y: defaultY
    })
  }

  bindEvents = () => {
    window.addEventListener('resize', this.resize)
    this.parent.addEventListener('mouseenter', this.handleEnter)
    this.parent.addEventListener('mouseleave', this.handleLeave)
    this.parent.addEventListener('mousemove', this.handleMove)
  }

  handleEnter = () => {
    this.resize()
    this.bindScroll()
  }

  handleLeave = () => {
    this.scrollOffset = 0
    this.mouseX = this.parentWidth / 2
    this.mouseY = this.parentHeight / 2
    this.unbindScroll()
  }

  bindScroll = () => {
    this.scrollStart = window.scrollY
    window.addEventListener('scroll', this.watchScroll)
  }

  unbindScroll = () => {
    window.removeEventListener('scroll', this.watchScroll)
  }

  watchScroll = () => {
    this.scrollOffset = (this.scrollStart - window.scrollY) * -1
    this.play()
  }

  handleMove = (e) => {
    this.mouseX = e.clientX - this.parentLeft
    this.mouseY = e.clientY - this.parentTop
    this.play()
  }

  play = () => {
    if (!this.paused) { return false }
    this.paused = false
    this.render()
  }

  pause = () => {
    if (this.paused) { return false }
    this.paused = true
  }

  render = () => {
    if (this.paused) { return false }
    this.updatePosition()
    window.requestAnimationFrame(this.render)
  }

  updatePosition = () => {
    if ((Math.abs(this.x - this.mouseX) < 0.5) && (Math.abs(this.y - this.mouseY) < 0.5)) { this.pause() }

    this.x = math.lerp(this.x, this.mouseX, this.lerp)
    this.y = math.lerp(this.y, this.mouseY + this.scrollOffset, this.lerp)
    TweenMax.set(this.child, {
      x: this.x - this.childWidth / 2,
      y: this.y - this.childHeight / 2,
    })
  }
}
